import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import { IDashboardCharts, IDashboardTotals } from '../../interfaces/dashboard.interfaces';
import { ICounsellor, ICounsellorsResponse } from '../../interfaces/counsellors.interfaces';

export interface IDashboardState {
  charts: IDashboardCharts | null;
  totals: IDashboardTotals | null;
  loadingTotals: boolean;
  errorTotals: string | null;
  counsellors: ICounsellor[];
  totalCounsellors: number | null;
  loadingCounsellors: boolean;
  errorCounsellors: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: IDashboardState = {
  charts: null,
  totals: null,
  loadingTotals: true,
  errorTotals: null,
  counsellors: [],
  totalCounsellors: null,
  loadingCounsellors: true,
  errorCounsellors: null,
  loading: true,
  error: null,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    loadChartsInfo: (state) => {
      state.loading = true;
      state.error = null;
    },
    loadChartsInfoSuccess: (state, { payload: charts }: PayloadAction<IDashboardCharts>) => {
      state.charts = charts;
      state.loading = false;
      state.error = null;
    },
    loadChartsInfoError: (state, { payload: error }: PayloadAction<string>) => {
      state.loading = false;
      state.error = error;
    },
    loadConsultationChartsInfo: (state) => {
      state.loadingTotals = true;
      state.errorTotals = null;
    },
    loadConsultationChartsInfoSuccess: (state, { payload: totals }: PayloadAction<IDashboardTotals>) => {
      state.totals = totals;
      state.loadingTotals = false;
      state.errorTotals = null;
    },
    loadConsultationChartsInfoError: (state, { payload: error }: PayloadAction<string>) => {
      state.loadingTotals = false;
      state.errorTotals = error;
    },
    loadCounsellorsRequest(state, { payload: { isFirstLoad } }: PayloadAction<{ isFirstLoad: boolean }>) {
      state.loadingCounsellors = true;
      state.errorCounsellors = null;
    },
    loadCounsellorsRequestSuccess: (state, { payload: { data, isFirstLoad } }: PayloadAction<{
      data: ICounsellorsResponse, isFirstLoad: boolean
    }>) => {
      state.counsellors = isFirstLoad ? data.experts : [...state.counsellors, ...data.experts];
      state.totalCounsellors = data.total_all;
      state.loadingCounsellors = false;
      state.errorCounsellors = null;
    },
    loadCounsellorsRequestFailure: (state, { payload: error }: PayloadAction<string>) => {
      state.loadingCounsellors = false;
      state.errorCounsellors = error;
    },
  }
});

export const DashboardSliceActions = dashboardSlice.actions;
